import React, { useState, useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import img from '../assets/Images/todo.jpg';
import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import BigTitle from '../subComponents/BigTitlte';
import { Light, darkTheme } from './Themes';

const MainContainer = styled(motion.div)`
  background-image: url(${img});
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
`;

const Container = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100%;
  min-height: 100vh;
  position: relative;
  padding: 2rem;
  box-sizing: border-box;
  transition: all 0.3s ease;
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5rem;
`;

const TodoList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  margin-top: 2rem;
  gap: 1rem;
`;

const TodoItem = styled(motion.div)`
  background-color: ${(props) => props.theme.card};
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;

const TaskInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TaskTitle = styled.h3`
  margin: 0;
  font-size: 1.2rem;
  color: ${(props) => props.theme.text};
`;

const StatusBadge = styled.span`
  padding: 0.3rem 0.6rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  background-color: ${(props) =>
    props.status === 'completed' ? '#4caf50' : '#ff9800'};
  color: white;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${(props) => props.theme.progressBg};
  border-radius: 4px;
  overflow: hidden;
  margin-top: 1rem;
`;

const Progress = styled.div`
  width: ${(props) => props.progress}%;
  height: 100%;
  background-color: #4caf50;
  transition: width 0.3s ease;
`;

const ExpandedView = styled(motion.div)`
  background-color: ${(props) => props.theme.expandedBg};
  border-radius: 0 0 10px 10px;
  padding: 1.5rem;
  margin-top: -10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ExpandedContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
`;

const DetailItem = styled.div`
  margin-bottom: 1rem;
`;

const DetailLabel = styled.span`
  font-weight: bold;
  color: ${(props) => props.theme.textLight};
  display: block;
  margin-bottom: 0.5rem;
`;

const DetailValue = styled.span`
  color: ${(props) => props.theme.text};
  display: block;
  line-height: 1.5;
`;

const ThemeToggle = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: ${(props) => props.theme.toggleBg};
  color: ${(props) => props.theme.toggleText};
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const LinkContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const LinkButton = styled.a`
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  text-decoration: none;
  color: white;
  background-color: ${(props) => props.color};
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

const TodoListPage = () => {
  const [todos, setTodos] = useState([]);
  const [expandedTask, setExpandedTask] = useState(null);
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  useEffect(() => {
    const fetchedTodos = [
      {
        id: 1,
        task: 'NeuraC',
        status: 'in progress',
        progress: 30,
        startDate: '2024-06-22',
        description:
          'Completing the visualisation part for the neuraC framework, have to commit some time for it, wanna launch it by July end.',
        githubLink: 'https://github.com/masterK0927/neuraC',
      },
      {
        id: 2,
        task: 'Understanding Brave Adblock.',
        status: 'in progress',
        progress: 10,
        startDate: '2024-07-13',
        description:
          'Understanding the working of Brave Adblocker native implementation and mimic Brave Shields and U-block-origin.',
        githubLink: 'https://github.com/brave/brave-core',
      },
      {
        id: 3,
        task: 'LlamaAtLocal',
        status: 'in progress',
        progress: 40,
        startDate: '2024-07-11',
        description:
          'Bundling a LLM into a chatbot application, which can run a whole llm at local without sending any data to the cloud. You just have to run the exe and it will automatically download a llm at local and will initiate a server process that will automatically create a llama.cpp server and connect exe GUI to it.',
        githubLink: 'https://github.com/masterK0927/llamaAtLocal',
      },
      {
        id: 4,
        task: 'Read source code of GCC',
        status: 'to start',
        progress: 0,
        startDate: '2024-07-14',
        description:
          'To start reading the source code of GCC on Github and exploring any technology which I will come across during that process.',
        githubLink: 'https://github.com/gcc-mirror/gcc',
      },
      {
        id: 5,
        task: 'Read the source code of BASH',
        status: 'to start',
        progress: 0,
        startDate: '2024-07-14',
        description:
          'To start reading the source code of Bash on Github and exploring any technology which I will come across during that process.',
        githubLink: 'https://github.com/bminor/bash',
      },
      {
        id: 6,
        task: 'Making online multiplayer games using Javascript and C',
        status: 'to start',
        progress: 0,
        startDate: '2024-07-18',
        description:
          'Want to make a online multiplayer game using javascript and C.',
      },
      {
        id: 7,
        task: 'Refactor codebase',
        status: 'in progress',
        progress: 20,
        startDate: '2024-07-13',
        description:
          'Start refactoring the minor ui bugs and code to improve performance and maintainability. Focus on the core ui fixes first.',
      },
    ];
    setTodos(fetchedTodos);
  }, []);

  const toggleExpand = (id) => {
    setExpandedTask(expandedTask === id ? null : id);
  };

  const calculateDaysPassed = (startDate) => {
    const start = new Date(startDate);
    const today = new Date();
    const diffTime = Math.abs(today - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
  };

  return (
    <ThemeProvider theme={isDarkTheme ? darkTheme : Light}>
      <MainContainer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Container>
          <LogoComponent theme={isDarkTheme ? 'dark' : 'light'} />
          <SocialIcons theme={isDarkTheme ? 'dark' : 'light'} />
          <PowerButton />
          <ThemeToggle onClick={toggleTheme}>
            {isDarkTheme ? '🌞' : '🌙'}
          </ThemeToggle>
          <Center>
            <BigTitle
              text="TODO LIST"
              top="2rem"
              left="50%"
              style={{ transform: 'translateX(-50%)' }}
            />
            <TodoList>
              {todos.map((todo) => (
                <motion.div key={todo.id} layout>
                  <TodoItem
                    onClick={() => toggleExpand(todo.id)}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <TaskInfo>
                      <TaskTitle>{todo.task}</TaskTitle>
                      <StatusBadge status={todo.status}>
                        {todo.status}
                      </StatusBadge>
                    </TaskInfo>
                    <ProgressBar>
                      <Progress progress={todo.progress} />
                    </ProgressBar>
                  </TodoItem>
                  <AnimatePresence>
                    {expandedTask === todo.id && (
                      <ExpandedView
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <ExpandedContent>
                          <DetailItem>
                            <DetailLabel>Description:</DetailLabel>
                            <DetailValue>{todo.description}</DetailValue>
                          </DetailItem>
                          <DetailItem>
                            <DetailLabel>Start Date:</DetailLabel>
                            <DetailValue>{todo.startDate}</DetailValue>
                          </DetailItem>
                          <DetailItem>
                            <DetailLabel>Days Passed:</DetailLabel>
                            <DetailValue>
                              {calculateDaysPassed(todo.startDate)} days
                            </DetailValue>
                          </DetailItem>
                          <DetailItem>
                            <DetailLabel>Progress:</DetailLabel>
                            <DetailValue>{todo.progress}%</DetailValue>
                          </DetailItem>
                          <LinkContainer>
                            {todo.githubLink && (
                              <LinkButton
                                href={todo.githubLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                color="#333"
                              >
                                GitHub
                              </LinkButton>
                            )}
                            {todo.blogLink && (
                              <LinkButton
                                href={todo.blogLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                color="#2196f3"
                              >
                                Blog
                              </LinkButton>
                            )}
                            {todo.youtubeLink && (
                              <LinkButton
                                href={todo.youtubeLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                color="#ff0000"
                              >
                                YouTube
                              </LinkButton>
                            )}
                          </LinkContainer>
                        </ExpandedContent>
                      </ExpandedView>
                    )}
                  </AnimatePresence>
                </motion.div>
              ))}
            </TodoList>
          </Center>
        </Container>
      </MainContainer>
    </ThemeProvider>
  );
};

export default TodoListPage;
